"use strict";

($dt => {

	const { on_nothing } = $dt.TopicGrid.Functions;

	/**
	 * Confirmation screen and form actual submit.
	 * 
	 * @param {Block} block 
	 * @param {InnerScreen} inner_screen 
	 * @param {*} controller 
	 */
	$dt.TopicGrid.ScreenFunctions.o0_i6 = (block, inner_screen, controller, toggle_left_pane) => {
		// Confirmation screen prior to attempting booking
		let canSubmitDeferredPricing = false;
		const { inner_elem } = inner_screen;
		const [ button_next_elem, button_prev_elem, button_next_text_elem, summary_elem ] = [
			inner_elem.querySelector('.button-next'),
			inner_elem.querySelector('.button-prev'),
			inner_elem.querySelector('.button-next .link-text'),
			inner_elem.querySelector('.schedule-summary')
		];

		button_prev_elem.addEventListener('click', () => {
			const { current_screen } = block;
			current_screen.outer = 0;
			current_screen.inner = 5;
			toggle_left_pane(true);
			controller.SetScreenUI(block);
		});

		$dt.OnDevelformsReady($df => {
			$df.RegisterFormPreparedEvent('eglxyorder', form => {

				const submit_form = () => {
					const { scheduling_info, d3df_page_options, current_topic, current_screen } = block;

					if (current_topic.deposit_amount !== null) {
						current_screen.outer = 2;
						current_screen.inner = 0;
						controller.SetScreenUI(block);
					} else if (!canSubmitDeferredPricing && current_topic.pricing_is_deferred) {
						// Need to show the custom message for this pricing deferred topic
						toggle_left_pane(true);
						summary_elem.innerHTML = current_topic.deferred_pricing_message;

						// Let the next click on this button finalize the transaction
						canSubmitDeferredPricing = true;
						button_next_elem.blur();
						button_next_text_elem.innerHTML = $dt.topic_button_texts.book_now;
					} else {
						controller.StartWaiting(block);

						// Submit final form processing
						form.currentContainer = inner_elem; // setting this for the error summary for API issues
						const data = {
							notes: scheduling_info.notes
						};

						// Known scheduling info for progressive form saving
						controller.SetSchedulingFormData(block, data);

						// Contact Info if Anonymous
						controller.SetContactInfoFormData(block, data);

						const on_complete = () => {
							controller.EndWaiting(block);
						};

						const on_validation_error = errors => {
							controller.FormValidationFailed(form, errors);
						};

						const on_success = resp => {
							// Save contact info
							scheduling_info.order_id = resp.entity.egalaxy_order_id.value;

							// Reset answers to questions
							scheduling_info.class_info_questions = [];

							// Transition Screen							
							current_screen.outer = 0;
							current_screen.inner = 7;

							controller.SetScreenUI(block);
						};

						// Update page options
						d3df_page_options.pageIndex = false; // final submit
						d3df_page_options.onSuccess = on_success;

						// Send to server for finalization
						form.submit(data, on_success, on_validation_error, on_nothing, on_complete, d3df_page_options);
					}
				};

				button_next_elem.addEventListener('click', $dt.Util.debounce(submit_form, $df.debounceThreshold));
				button_next_elem.removeAttribute('disabled');
			});
			
		});

		// Load Confirmation Details
		inner_screen.Show = () => {
			const { current_topic } = block;
			canSubmitDeferredPricing = !current_topic.pricing_is_deferred;

			if (current_topic.deposit_amount !== null || current_topic.pricing_is_deferred) {
				button_next_text_elem.innerHTML = $dt.topic_button_texts.checkout;
			} else {
				button_next_text_elem.innerHTML = $dt.topic_button_texts.book_now;
			}

			summary_elem.innerHTML = controller.CreateHtmlSummary(block, true, false, false);

			// Restore left pane to avoid showing double info
			toggle_left_pane(false);
		};
	};

})(window.d3_wp_themejs);
